// @author Jeremy Berecz
// @not very proud because it's an old snippet of mine that have 5 years
// store the currently selected tab in the hash value
// @param cookie_name (String): name of the cookie where information will be stored
// @param select_id (String): id attribute of the select html element
// @param list_href (String): prefix of the href of the list html element
window.store_select_tab_cookie = function(cookie_name) {
  $('ul[id="'+ cookie_name +'"] a').on('shown.bs.tab', function (e) {
    var id = $(e.target).attr('href').substr(1);
    selected = $.cookie(cookie_name, id, { expires: 7, path: '/' });
    tab = $.cookie(cookie_name);
    $("div[id=" + tab).addClass( "tab-pane active" );
  });
}

// @author Jeremy Berecz
// @not very proud because it's an old snippet of mine that have 5 years
// on load of the page: switch to the currently selected tab
// @param cookie_name (String): name of the cookie where information will be stored
// @param select_id (String): id attribute of the select html element
// @param list_href (String): prefix of the href of the list html element
// @param list_id (String): id attribute of the div html element where panel are contained
window.default_select_panel_element = function(cookie_name) {
  var hash = $.cookie(cookie_name);
  if (hash == null) {
    var a = $('#' + cookie_name + ' a')[0];
    hash = $.cookie(cookie_name, a.href.split("#")[1],{ expires: 7, path: '/' });
  }
  tabContent = $.cookie(cookie_name);
  $('ul[id="'+ cookie_name +'"] a[href="#' + tabContent + '"]').tab('show');
}

// @author Jeremy Berecz
// @not very proud because it's an old snippet of mine that have 5 years
// store the currently selected tab in the hash value
// @param cookie_name (String): name of the cookie where information will be stored
// @param select_id (String): id attribute of the select html element
// @param list_href (String): prefix of the href of the list html element
window.store_menu_cookie = function(cookie_name) {
  $('#accordionSidebar li .menu').on('click', function (e) {
    $('#accordionSidebar li').removeClass( "active" );
    var id = $(this).parent().attr('data-name');
    selected = $.cookie(cookie_name, id, { expires: 7, path: '/' });
    $("li[data-name='" + selected.split("=")[1] +"'").addClass( "active" );
  });
}

window.default_menu_active_element = function(cookie_name) {
  $('#accordionSidebar li').removeClass( "active" );
  var hash = $.cookie(cookie_name);
  if (hash == null) {
    $.cookie(cookie_name,"dashboard", { expires: 7, path: '/' });
  }
  var menu = $.cookie(cookie_name);
  $("#accordionSidebar li[data-name=" + menu).addClass( "active" );
}

window.store_menu_admin_cookie = function(cookie_name) {
  $('#accordionSidebar li .choose').on('click', function (e) {
    $.cookie(cookie_name, $(this).parent().attr('data-name'), { expires: 7, path: '/' });
    $.cookie("menu","dashboard", { expires: 7, path: '/' });
    selected = $.cookie(cookie_name);
    if(selected == "admin"){
      $('li[data-name="admin"]').hide();
      $('li[data-name="user"]').show();
      $('#accordionSidebar .user-item').hide();
      $('#accordionSidebar .admin-item').show();
    }else{
      $('li[data-name="admin"]').show();
      $('li[data-name="user"]').hide();
      $('#accordionSidebar .user-item').show();
      $('#accordionSidebar .admin-item').hide();
    }
  });
}

window.default_menu_admin_active_element = function(cookie_name) {
  var hash = $.cookie(cookie_name);
  if (hash == null) {
    $.cookie(cookie_name,"admin", { expires: 7, path: '/' });
    window.location.replace("/admins/dashboard");
  }
  hash = $.cookie(cookie_name);
  if(hash == "admin"){
    $('li[data-name="admin"]').hide();
    $('li[data-name="user"]').show();
    $('#accordionSidebar .user-item').hide();
    $('#accordionSidebar .admin-item').show();
  }else{
    $('li[data-name="admin"]').show();
    $('li[data-name="user"]').hide();
    $('#accordionSidebar .user-item').show();
    $('#accordionSidebar .admin-item').hide();
  }
}

window.collapse_menu = function(cookie_name){
  hash = $.cookie(cookie_name);
  if (hash == null) {
    $.cookie(cookie_name,"open", { expires: 7, path: '/' });
  }
  collapsed = $.cookie(cookie_name);
  if(collapsed == 'toggled'){
    $("body").removeClass("sidebar-toggled");
    $(".sidebar").removeClass("toggled");
  }else{
    $("body").addClass("sidebar-toggled");
    $(".sidebar").addClass("toggled");
    $('.sidebar .collapse').collapse('hide');
  }
}

$("#sidebarToggle").on('click', function (e) {
  collapsed = $.cookie('sidebar');
  console.log(collapsed);
  if(collapsed == 'toggled'){
    $("body").removeClass("sidebar-toggled");
    $(".sidebar").removeClass("toggled");
    $.cookie('sidebar', "open",{ expires: 7, path: '/' });
  }
  else
  {
    $("body").addClass("sidebar-toggled");
    $(".sidebar").addClass("toggled");
    $('.sidebar .collapse').collapse('hide');
    $.cookie('sidebar', "toggled",{ expires: 7, path: '/' });

  }
  window.location.reload();
});